import { render, staticRenderFns } from "./quotes-block.vue?vue&type=template&id=6e158db6&scoped=true"
var script = {}
import style0 from "./quotes-block.vue?vue&type=style&index=0&id=6e158db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e158db6",
  null
  
)

export default component.exports